import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NewMeasurementPointPhotoModel, ReportConfigVM } from '../../models/rope-shovel.model';
import { NotificationsService } from 'angular2-notifications';
import { RopeShovelService } from '../../rope-shovel.service';

@Component({
  selector: 'upload-component-photo',
  templateUrl: './upload-component-photo.component.html',
  styleUrls: ['./upload-component-photo.component.scss']
})
export class UploadComponentPhotoComponent implements OnInit {
  @Input() inspectionDetailId: number = 0;
  @Input() compartMeasurePointId: number = 0;
  @Input() ReportId:number=0;
  @Input() CompartTypeID:number=0;
  @Input() MiningShovelReportId:number=0;

  @Output() onPhotoUpload: EventEmitter<any> = new EventEmitter();
  photo: string = '';
  photoLoading = false;
  constructor(private _service: RopeShovelService,
    private _notify: NotificationsService,) { }

  ngOnInit() {
    //(rotatedImage.src).split(",")[1]
  }

  // onSelectPhoto(event) {
  //   if (event.target.files && event.target.files[0]) {
  //     var reader = new FileReader();
  //     reader.readAsDataURL(event.target.files[0]); // read file as data url

  //     reader.onload = (event: FileReaderEvent) => { // called once readAsDataURL is completed
  //       this.photo = event.target.result;
  //       //this.uploadMeasurementPointPhoto(this.photo);

        
  //       //this.newPhoto = event.target.result;

  //       //resize photo
  //       this.compressImage(this.photo).then((res: string) => {
  //         if (res) {
  //           this.uploadMeasurementPointPhoto(res);
  //         }
  //       })
  //     }
  //   }
  // }
  onSelectPhoto(event: any) {
    this.photoLoading = true;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data URL
  
      reader.onload = (event: ProgressEvent<FileReader>) => { // called once readAsDataURL is completed
        if (event.target && event.target.result) {
          this.photo = event.target.result as string; // Cast result to string
  
          // Resize photo
          this.compressImage(this.photo).then((res: string) => {
            if (res) {
              this.uploadMeasurementPointPhoto(res);
            }
          });
        }
      };
    }
  }
  
  private compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');

        let width, height;
        width = img.width;
        height = img.height;

        console.log('width', width)
        console.log('height', height)

        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height


        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }
  uploadMeasurementPointPhoto(p: string) {
   /// this._notify.info('Uploading', 'Uploading your photo now...');
    let uploadModel = new NewMeasurementPointPhotoModel(this.inspectionDetailId, this.compartMeasurePointId, p.split(",")[1]);
    this._service.uploadNewMeasurementPointPhoto(uploadModel).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Uploaded', r.m_Item2);
        let params = new ReportConfigVM();
                params.Id = this.ReportId ;
                params.CompartTypeId = this.CompartTypeID;
                params.MiningShovelReportId = this.MiningShovelReportId;
                params.OptionType = 'IncludeMeasurementImage';
                params.OptionTypeChecked = true;
                params.InspectionId = this.inspectionDetailId;
                //params.SortOrder = SortOrder;
                this._service.SetRSReportMeasurementPointConfig(params).subscribe(res => {
                  if (res) {
                    
                      
                  }
                });
                this.onPhotoUpload.emit(null);
        
       // this.photoLoading = false;
      } else {
        this._notify.error('Failed', r.m_Item2);
        console.log(r);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to upload photo. Please contact TrackTreads support. ');
      console.log(err);
    });
  }
}

interface FileReaderEventTarget extends EventTarget {
  result: string
}

interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}
